module.exports = __webpack_public_path__ + "media/images/empresa/emp_cred-11eaf9f0c087e246c039e6d66d2f142b.svg";